export default __webpack_public_path__ + "static/media/1422.06438117.jpg";